/**
 * margen — die Marge VOM NETTOPREIS, an einer Stelle statt an vier (EK-A19).
 *
 * 🔴 Im Haus gibt es eine ZWEITE Margenzahl, und sie misst etwas anderes:
 * `shp_products.margin_relative` ist der **Aufschlag auf den EK**
 * (`netto / ek - 1`, `sync/sync_products.py`). Aus ihr entstehen die Klassen
 * `margin_cat`, daraus die Shopify-Tags und daraus die Google-Ads-Label.
 * Dieselbe Lage ergibt hier **50** und dort **100** (EK 100, Netto 200).
 * Beide Zahlen sind richtig — sie beantworten verschiedene Fragen. Wer sie
 * angleicht, aendert eine Zahl, an der Geld haengt: das ist eine eigene
 * Entscheidung mit eigener Ansage, keine Aufraeumarbeit.
 *
 * @param netto Nettopreis (Listenpreis ohne Steuer)
 * @param ek    Einkaufspreis
 * @returns Prozent vom Netto, oder `null`, wenn es keinen Nettopreis gibt.
 *          🔴 `null`, nicht 0 — die Aufrufer entscheiden, was sie anzeigen.
 */
export function margeProzentVomNetto(netto, ek) {
  const n = Number(netto);
  if (!(n > 0)) return null;
  return ((n - Number(ek ?? 0)) / n) * 100;
}
